import { motion } from 'framer-motion';
import { PortableText } from '@portabletext/react';
import animations from 'utils/animations';
import Media from 'components/Media';

export default function Section({ name, id, customClass, title, description, media, children }) {
  const { opacity, opacityAndMove } = animations.components;

  return (
    <section id={id} className={customClass}>

      <div className="container">
        <div className="section-content">
          <motion.span 
            {...opacityAndMove}
            transition={{ delay: .1}}
            className="tag-sm">
              {name}
          </motion.span>

          <motion.h2 
            {...opacity}
            transition={{ delay: .2 }}
            className="k-title-xs xl:k-title-sm">
              {title}
          </motion.h2>

          <motion.div 
            {...opacity}
            transition={{ delay: .3 }}
            className='section-description'>
            <PortableText 
              value={description}
              components={{
                block: {
                  normal: ({ children }) => (
                    <p className="k-text-md xl:k-text-lg">{children}</p>
                  ),
                },
              }}
            />
          </motion.div>
        </div>

        {children}
      </div>

      {(media.leftColumnMedia?.source || media.rightColumnMedia?.source) && (
        <div className="container-full container-img">
          <div>
            <Media source={media.leftColumnMedia.source} controls={media.leftColumnMedia.controls} />
          </div>
          <div>
            <Media source={media.rightColumnMedia.source} controls={media.rightColumnMedia.controls} />
          </div>
        </div>
      )}

      {media.fullWidthMedia.source && (
        <div className="container-img-full">
          <Media source={media.fullWidthMedia.source} controls={media.fullWidthMedia.controls} />
        </div>
      )}
    </section>
  );
}
